<template>
  <el-dialog
    title="申请免费体验"
    :visible.sync="dialogVisible"
    custom-class="trial-dialog"
    width="520px"
    center
    append-to-body
    @close="handleClose"
  >
    <p class="trial-dialog-intro">留下联系方式，我们将尽快为您提供专属服务咨询。<span class="required-tip"></span></p>
    <div class="trial-form-row">
      <label for="trial-name"><span class="required-mark">*</span>姓名</label>
      <el-input id="trial-name" v-model="userName" placeholder="请输入您的姓名" />
    </div>
    <div class="trial-form-row">
      <label for="trial-affiliation"><span class="required-mark">*</span>所属单位</label>
      <el-input id="trial-affiliation" v-model="affiliation" placeholder="请输入您的单位名称" />
    </div>
    <div class="trial-form-row">
      <label for="trial-phone"><span class="required-mark">*</span>电话号码</label>
      <el-input id="trial-phone" v-model="phone" placeholder="请输入您的手机号码" />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="trial-cancel" @click="close">取消</el-button>
      <el-button class="trial-submit" type="primary" @click="submit">提交申请</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { insertUserInfo } from '@/api/kms/userInfo'
import { Message } from 'element-ui'

export default {
  name: 'TrialDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      phone: '',
      userName: '',
      affiliation: ''
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  methods: {
    handleClose () {
      this.resetForm()
      this.$emit('close')
    },
    close () {
      this.dialogVisible = false
    },
    resetForm () {
      this.phone = ''
      this.userName = ''
      this.affiliation = ''
    },
    submit () {
      const regTel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (!this.phone) return this.$message({ type: 'warning', message: '手机号不能为空' })
      if (!regTel.test(this.phone)) return this.$message({ type: 'warning', message: '请输入正确格式的电话号码' })
      if (!this.userName) return this.$message({ type: 'warning', message: '姓名不能为空' })
      if (!this.affiliation) return this.$message({ type: 'warning', message: '单位不能为空' })

      insertUserInfo({ phone: this.phone, userName: this.userName, affillation: this.affiliation }).then(response => {
        if (response.data.code === '200') {
          Message({ message: '申请成功，我们的客户将在稍后与您进行联系', type: 'success' })
          this.close()
        } else {
          Message({ message: response.data.msg, type: 'error' })
        }
      })
    }
  }
}
</script>

<style>
.el-message { z-index: 10000 !important; }
.trial-dialog .el-dialog { border-radius: 8px; overflow: hidden; }
.trial-dialog .el-dialog__header { padding: 25px 30px 12px; border-bottom: 1px solid #edf1f6; }
.trial-dialog .el-dialog__title { color: #20344e; font-size: 20px; font-weight: 600; }
.trial-dialog .el-dialog__body { padding: 25px 30px 10px; }
.trial-dialog .el-dialog__footer { padding: 10px 30px 25px; }
.trial-dialog-intro { margin: -8px 0 25px; color: #7a899c; font-size: 14px; line-height: 1.7; text-align: center; }
.required-tip { color: #a0adbd; }
.required-mark { margin-right: 3px; color: #f56c6c; font-weight: 600; }
.trial-form-row { display: flex; align-items: center; gap: 18px; margin: 18px 0; }
.trial-form-row > label { flex: 0 0 70px; color: #304660; font-size: 14px; font-weight: 500; text-align: right; }
.trial-form-row .el-input { flex: 1; }
.trial-form-row .el-input__inner { height: 44px; border-color: #dce5ef; border-radius: 5px; color: #20344e; transition: border-color .2s ease, box-shadow .2s ease; }
.trial-form-row .el-input__inner:focus { border-color: #1f5dea; box-shadow: 0 0 0 3px rgba(31, 93, 234, .1); }
.dialog-footer { display: flex; justify-content: flex-end; gap: 12px; padding-top: 8px; }
.trial-cancel, .trial-submit { min-width: 92px; height: 38px; border-radius: 4px; font-size: 14px; }
.trial-cancel { border-color: #dce5ef; color: #61748b; }
.trial-submit { border: 0; background: #1f5dea; }
@media (max-width: 560px) {
  .trial-dialog .el-dialog { width: calc(100% - 32px) !important; }
  .trial-dialog .el-dialog__header { padding: 20px 20px 10px; }
  .trial-dialog .el-dialog__body { padding: 20px 20px 5px; }
  .trial-dialog .el-dialog__footer { padding: 8px 20px 20px; }
  .trial-dialog .el-dialog__title { font-size: 18px; }
  .trial-dialog-intro { font-size: 13px; }
  .trial-form-row { align-items: stretch; flex-direction: column; gap: 7px; margin: 16px 0; }
  .trial-form-row > label { flex-basis: auto; text-align: left; }
  .dialog-footer { padding-top: 4px; }
}
</style>
